import React, { useState, useEffect } from "react";
import { useHeaderNavigationContext } from "../context/HeaderNavigationContext";

interface ConsoleComponentProps {
  words?: string[];
  colors?: string[];
  isNavOpen: boolean;
  setIsNavOpen: (isOpen: boolean) => void;
}

const ConsoleComponent: React.FC<ConsoleComponentProps> = ({
  words = ["", "", ""],
  colors = ["", "", ""],
}) => {
  const [currentWord, setCurrentWord] = useState<string>("");
  const [currentColor, setCurrentColor] = useState<string>(colors[0]);
  const [isUnderscoreVisible, setIsUnderscoreVisible] = useState<boolean>(true);
  let [letterCount, setLetterCount] = useState<number>(1);
  let [waiting, setWaiting] = useState<boolean>(false);
  let [wordIndex, setWordIndex] = useState<number>(0);
  const { isNavOpen, setIsNavOpen } = useHeaderNavigationContext();

  useEffect(() => {
    const typingInterval = setInterval(() => {
      if (!waiting) {
        if (letterCount === 0 || letterCount === words[wordIndex].length + 1) {
          setWaiting(true);
          setTimeout(() => {
            cycleWord();
            setWaiting(false);
          }, 1000);
        } else {
          setCurrentWord(words[wordIndex].substring(0, letterCount));
          setLetterCount(
            letterCount + (letterCount === words[wordIndex].length + 1 ? 0 : 1)
          );
        }
      }
    }, 120);

    const underscoreInterval = setInterval(() => {
      setIsUnderscoreVisible(!isUnderscoreVisible);
    }, 400);

    return () => {
      clearInterval(typingInterval);
      clearInterval(underscoreInterval);
    };
  }, [words, colors, letterCount, waiting, wordIndex, isUnderscoreVisible]);

  const cycleWord = () => {
    let newIndex = (wordIndex + 1) % words.length;
    setWordIndex(newIndex);
    setLetterCount(1);
    setCurrentColor(colors[newIndex % colors.length]);
  };

  return (
    <div
      className="inline-block"
      style={{ fontFamily: "Khula", fontSize: "1em" }}
    >
      <span style={{ color: currentColor }}>{currentWord}</span>
      <span
        className={`inline-block relative z-10 ${
          isUnderscoreVisible ? "" : "opacity-0"
        } ${isNavOpen ? "hidden" : ""}`}
        style={{ top: "-0.14em", left: "10px" }}
      >
        _
      </span>
    </div>
  );
};

export default ConsoleComponent;
